const STATUS_CODES = {
	AUTH: {
		TEMPORARY_PASSWORD_EXPIRED: 10140104,
	},
	ADMIN_VENDOR_CHAT: {
		ADMIN_VENDOR_CHAT_DO_NOT_EXIST: 14440002,
	},
};

export default STATUS_CODES;
